import { GETScoreDataSource } from "./score.requests";
import { scoreStore } from "./score.store";

export class ScoreQuery {
  store = scoreStore;

  scores$ = GETScoreDataSource.data$();
}

export const scoreQuery = new ScoreQuery();